import { OFFLINE_COMPONENT_TRANSLATIONS } from "@/components/offline/constants";
import { useConnectivity } from "@/domains/offline/connectivity/useConnectivity";
import { useSyncStatus } from "@/domains/offline/hooks/useSyncStatus";
import { getTranslation } from "@mivo/i18n";

export default function OfflineBanner() {
  const isOnline = useConnectivity();
  const { state, pendingCount, failedCount } = useSyncStatus();

  if (isOnline && pendingCount === 0 && failedCount === 0 && state !== "syncing") {
    return null;
  }

  let message: string = getTranslation(OFFLINE_COMPONENT_TRANSLATIONS.bannerOfflineMessage);
  if (isOnline && state === "syncing") {
    message = getTranslation(OFFLINE_COMPONENT_TRANSLATIONS.bannerSyncing);
  } else if (isOnline && pendingCount > 0) {
    message = getTranslation(OFFLINE_COMPONENT_TRANSLATIONS.bannerPendingCount).replace(
      "{count}",
      String(pendingCount),
    );
  } else if (failedCount > 0) {
    message = getTranslation(OFFLINE_COMPONENT_TRANSLATIONS.bannerFailedCount).replace(
      "{count}",
      String(failedCount),
    );
  }

  return (
    <div
      role="status"
      data-testid="offline-banner"
      className={`sticky top-0 z-40 border-b px-4 py-2.5 text-center text-sm font-semibold sm:px-6 ${
        isOnline ? "border-border bg-secondary text-secondary-foreground" : "border-destructive bg-destructive/10 text-destructive"
      }`}
    >
      {message}
    </div>
  );
}
